// Lê um stream SSE do backend do chat e produz os chunks de texto.
// Linhas inválidas ou sem texto são ignoradas (mesmo comportamento do ChatBot original).
export async function* readChatStream(reader) {
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n');
    buffer = lines.pop();

    for (const line of lines) {
      if (!line.startsWith('data: ')) continue;
      const data = line.slice(6);
      if (data === '[DONE]') continue;
      try {
        const { text } = JSON.parse(data);
        if (text) yield text;
      } catch {} // linhas malformadas são ignoradas
    }
  }
}

// Constrói um reader a partir de uma resposta do fetch
export function getChatReader(response) {
  return response.body.getReader();
}
